import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth';

// Guard to prevent logged-in users from accessing login/signup routes
export const NoAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    // If already logged in, redirect to dashboard or home
    router.navigate(['/dashboard']);
    return false;
  }
  return true;
};
